import { App as AntApp, ConfigProvider } from 'antd';
import DialogManager from 'components/DialogManager/DialogManager';
import { AppContext } from 'contexts/AppContext';
import { useContext, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ShowToastInitializer } from 'utils/ShowToast';

import PageRoutes from './page-routes';

import './App.css';

const theme = {
  token: {
    colorPrimary: '#5d87ff',
    colorSuccess: '#13deb9',
    colorWarning: '#ffba19',
    colorError: '#fa896b',
    colorTextBase: '#2a3547',
    colorTextSecondary: '#6b6f82',
    colorBorder: '#d8dee4',
    colorBgBase: '#ffffff',
    colorBgLayout: '#f4f4f6',
    borderRadius: 0,
    fontFamily: "'Montserrat', sans-serif",
  },
};

const App = () => {
  const {
    state: { settings },
    actions: { fetchApps, fetchMe },
  } = useContext(AppContext);

  useEffect(() => {
    fetchApps();
    fetchMe();
  }, [fetchApps, fetchMe]);

  return (
    <ConfigProvider theme={theme}>
      <AntApp>
        <ShowToastInitializer />
        <BrowserRouter
          basename="/"
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <div>{settings.favicon && <link rel="icon" href={settings.favicon} />}</div>
          <PageRoutes />
        </BrowserRouter>
        <DialogManager />
      </AntApp>
    </ConfigProvider>
  );
};

export default App;
